let common = require('./modules/common');

function init() {
    let myMap = new ymaps.Map("map", {
            center: [59.965344, 30.315002],
            zoom: 17
        }, {
            searchControlProvider: 'yandex#search'
        }),

        // Создаем геообъект с типом геометрии "Точка".
        myGeoObject = new ymaps.GeoObject({
            // Описание геометрии.
            geometry: {
                type: "Point",
                coordinates: [59.965344, 30.315002]
            }
        });
    myMap.geoObjects.add(myGeoObject);
}

if (document.getElementById('map') !== null) {
    let s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
    s.addEventListener('load', function () {

        ymaps.ready(init);

    });
    let ss = document.getElementsByTagName('script')[0];
    ss.parentNode.insertBefore(s, ss);
}